import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HhsgSharedConfigService } from "./config.service";

@Injectable()
export class HhsgSharedQuicksightService {
    private readonly apiServer: string;

    constructor(private _http: HttpClient, private configService: HhsgSharedConfigService) {
        this.apiServer = this.configService.appSettings.quicksightApiUrl;
    }

    public getDashboardUrl(dashboardId: string,dashboardParameters:object): Observable<any> {        
        let params = new HttpParams().set('id', dashboardId.toString());
        Object.keys(dashboardParameters).forEach(key => {
            params = params.append(dashboardParameters[key]['urlKey'],dashboardParameters[key]['data'].toString());
        });
        return this._http.get(`${ this.apiServer }get-qs-embed-url`, { params: params });
    }
}